import React from "react";
import { Button, Container } from "react-bootstrap";
import { MdLogin } from "react-icons/md";
import { useSelector } from "react-redux";
import { Route, useNavigate } from "react-router-dom";

const PrivateRoutesCompany = ({ children, ...rest }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const profileData = useSelector((state) => state.auth.myProfile);
  const navigate = useNavigate();

  return isLoggedIn && profileData?.client_user_details?.is_corporate_admin ? (
    children
  ) : !isLoggedIn || profileData?.client_user_details?.is_corporate_admin === false ? (
    <Container className="mainContent text-center">
      <MdLogin size="50px" />
      <h1 className="my-3">Access Restricted</h1>
      <p>You need to login as Company Admin to access this content. </p>
      <Button
        onClick={() => navigate("?action=login")}
      >
        Back to Home
      </Button>
    </Container>
  ) : (
    ""
  );
};

export default PrivateRoutesCompany;
